import { createAsyncThunk } from '@reduxjs/toolkit'
import { API } from '../dataServise'
import { baseURL } from "../../../utils/constants";

const apiUrl = `${baseURL}/admin/faq`

export const getFAQs = createAsyncThunk(
  'GET_FAQS',
  async ({page=1}, thunk) => {
    try {
      const { data } = await API.get(`${apiUrl}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)
export const getOneFAQ = createAsyncThunk(
  'GET_ONE_FAQ',
  async (id, thunk) => {
    try {
      const { data } = await API.get(`${apiUrl}/${id}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const createFAQ = createAsyncThunk(
  'CREATE_FAQ',
  async (body, thunk) => {
    console.log(body);
    
    try {
      const { data } = await API.post(`${apiUrl}`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const updateFAQ = createAsyncThunk(
  'UPDATE_FAQ',
  async ({id, body}, thunk) => {
    try {
      const { data } = await API.put(`${apiUrl}/${id}`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const deleteFAQ = createAsyncThunk(
  'DELETE_FAQ',
  async (id, thunk) => {
    try {
      const { data } = await API.delete(`${apiUrl}/${id}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)


export const getClientFAQs = createAsyncThunk(
  'GET_FAQS',
  async ({page=1}, thunk) => {
    try {
      const { data } = await API.get(`${apiUrl}/client`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)
export const getOneClientFAQ = createAsyncThunk(
  'GET_ONE_FAQ',
  async (id, thunk) => {
    try {
      const { data } = await API.get(`${apiUrl}/client/${id}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const createClientFAQ = createAsyncThunk(
  'CREATE_FAQ',
  async (body, thunk) => {
    console.log(body);
    
    try {
      const { data } = await API.post(`${apiUrl}/client`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const updateClientFAQ = createAsyncThunk(
  'UPDATE_FAQ',
  async ({id, body}, thunk) => {
    try {
      const { data } = await API.put(`${apiUrl}/client/${id}`, body)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)

export const deleteClientFAQ = createAsyncThunk(
  'DELETE_FAQ',
  async (id, thunk) => {
    try {
      const { data } = await API.delete(`${apiUrl}/client/${id}`)
      return data
    } catch (exception) {
      if (exception.response?.data.message) {
        return thunk.rejectWithValue(exception.response.data.message)
      } else throw exception
    }
  },
)